<template>
    <span class="mobile-bottom-nav__item__live-indicator">
        <span>{{ label }}</span>
    </span>
</template>
<script>
    import { mapGetters } from 'vuex';

    export default {
        props: {
            count: {
                type: String,
                required: false,
                default: null,
            },
        },
        computed: {
            ...mapGetters('data/sportOffer', ['liveEventsCount']),
            label() {
                return this.count ?? this.liveEventsCount;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .mobile-bottom-nav__item__live-indicator {
        font-variant-numeric: tabular-nums;
    }
</style>
